import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../../components/LoaderScreen";
import request from "../../../../Helpers/API";
import { CondonacionInteresListado } from "./CondonacionInteresListado";
import { CondonacionInteresAgregar } from "./CondonacionInteresAgregar";

// Punto de entrada desde DetalleClientesScreen, o desde una notificación (RedireccionNotificaciones)
// que solo trae { folio } sin idcliente/razonsocial — con folio entra directo al modo aprobación
// de esa condonación específica; sin folio, CondonacionIntereses/ValidarCondonacionesCliente
// decide entre listado y captura.
export const CondonacionInteresScreen = () => {
    const history = useHistory();
    const { state } = useLocation();
    const folioInicial = state?.folio || null;
    // Listado global de condonaciones (todos los clientes), solo accesible desde el card del
    // dashboard — no hay cliente ni facturas de por medio, ni endpoint de validación aplicable.
    const esGlobal = !folioInicial && (!state?.idcliente || Number(state.idcliente) === 0);
    const sinFacturasSeleccionadas = !state?.facturasSeleccionadas || state.facturasSeleccionadas.length === 0;
    // Al entrar por notificación solo llega { folio }, sin idcliente/razonsocial — en ese caso no
    // hay listado/captura de cliente a los que volver, solo se puede regresar de la pantalla.
    const sinContextoCliente = !state?.idcliente;
    const [tieneCondonaciones, setTieneCondonaciones] = useState(false);
    const [tienePendiente, setTienePendiente] = useState(false);
    const [cargando, setCargando] = useState(!folioInicial && !esGlobal);
    const [modo, setModo] = useState(folioInicial ? "aprobar" : "listado");
    const [folioAprobar, setFolioAprobar] = useState(folioInicial);

    const validarCliente = () => {
        setCargando(true);
        request
            .post(`CondonacionIntereses/ValidarCondonacionesCliente?idcliente=${state.idcliente}`, {})
            .then((result) => {
                const hayCondonaciones = (result?.total_condonaciones || 0) > 0;
                const hayPendiente = Boolean(result?.tiene_pendiente);
                setTieneCondonaciones(hayCondonaciones);
                setTienePendiente(hayPendiente);
                // Sin condonaciones previas y sin facturas seleccionadas no hay nada que capturar
                // — se pide seleccionar una factura desde el detalle del cliente en vez de abrir
                // la pantalla de registro vacía.
                if (!hayCondonaciones && sinFacturasSeleccionadas) {
                    Swal.fire(
                        "CONDONACIÓN DE INTERÉS",
                        "Selecciona al menos una factura del cliente para poder capturar una condonación.",
                        "warning"
                    ).then(() => history.goBack());
                    return;
                }
                // Con facturas seleccionadas se va directo a captura, tenga o no condonaciones
                // previas — salvo que ya haya una pendiente de autorizar, que sigue bloqueando.
                if (!sinFacturasSeleccionadas && hayPendiente) {
                    Swal.fire(
                        "CONDONACIÓN DE INTERÉS",
                        "No puedes realizar otra condonación a este cliente hasta que se autorice o rechace la que está pendiente.",
                        "warning"
                    ).then(() => history.goBack());
                    return;
                }
                setModo(!sinFacturasSeleccionadas ? "agregar" : hayCondonaciones ? "listado" : "agregar");
                setCargando(false);
            })
            .catch(() => {
                setCargando(false);
                Swal.fire("CONDONACIÓN DE INTERÉS", "No se pudo consultar la información del cliente.", "error");
            });
    };

    useEffect(() => {
        if (folioInicial || esGlobal) return;
        validarCliente();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (cargando) {
        return <LoaderScreen loader={{ mostrar: true, alerta: false, error: false, mensaje: "" }} />;
    }

    if (modo === "aprobar") {
        return (
            <CondonacionInteresAgregar
                folio={folioAprobar}
                onCancelar={sinContextoCliente ? null : () => setModo("listado")}
                onGuardado={sinContextoCliente ? null : validarCliente}
            />
        );
    }

    if (modo === "agregar") {
        return (
            <CondonacionInteresAgregar
                onCancelar={tieneCondonaciones ? () => setModo("listado") : null}
                onGuardado={validarCliente}
            />
        );
    }

    const onNuevaCondonacion = () => {
        // El listado se puede alcanzar sin haber seleccionado facturas (cliente con condonaciones
        // previas) — sin ellas no hay nada que capturar en una nueva condonación.
        if (sinFacturasSeleccionadas) {
            Swal.fire(
                "CONDONACIÓN DE INTERÉS",
                "Selecciona al menos una factura del cliente para poder capturar una nueva condonación.",
                "warning"
            );
            return;
        }
        setModo("agregar");
    };

    return (
        <CondonacionInteresListado
            tienePendiente={tienePendiente}
            onNuevaCondonacion={onNuevaCondonacion}
            onAprobarCondonacion={(folioSeleccionado) => {
                setFolioAprobar(folioSeleccionado);
                setModo("aprobar");
            }}
        />
    );
};

export default CondonacionInteresScreen;
